import React from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { withPageTracking } from "../../../services/postHog";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { FruitifyQuizSearch } from "../components/FruitifyQuizSearch";

const QuizOverview = () => {
  const navigate = useNavigate();

  return (
    <FruitifyContainer>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        gap={2}
        mb={2}
      >
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          <Typography variant="h3" fontWeight="bold">
            Quizzes
          </Typography>
        </Stack>
        <Button
          variant="contained"
          endIcon={<Add />}
          onClick={() => navigate("create")}
        >
          Create Quiz
        </Button>
      </Box>
      <FruitifyQuizSearch excludeTitle />
    </FruitifyContainer>
  );
};

export default withPageTracking(QuizOverview, {
  feature: "quiz-overview",
});
